export const config = {
  title: 'Change Status',
  okText: 'Apply',
  width: 420,
  showSelectedCount: true,
  fields: [
    {
      name: 'status',
      label: 'New Status',
      type: 'select',
      required: true,
      placeholder: 'Select a status',
      dataSource: 'master',
      masterName: 'clientSubmissions',
      labelKey: 'name',
      valueKey: 'name',
      initialValueKey: 'currentStatus',
      defaultOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' },
        { label: 'Pending', value: 'pending' },
        { label: 'Closed', value: 'closed' },
      ],
    },
  ],
};
